import { EditionStatus, EditionType } from '@graphics/gfx-common/dist/constants'
import {
  IEditionMetadata,
  GroupedEditionsType,
  SingleEditionType,
  IArchive,
  IEditionMetadataInput,
} from '../types/pack'
import { orderByCreatedDateAscending } from './date'

export const groupEditions = (
  editions: IEditionMetadata[]
): GroupedEditionsType => {
  const modifiedEditions = editions
    .map(
      (edition, i): SingleEditionType => ({
        checked: true,
        editionIndex: `${i}`,
        ...edition,
      })
    )
    .sort(orderByCreatedDateAscending)
  const singleEditions = modifiedEditions.filter(
    ({ editionType }) => editionType !== EditionType.GraphicFolder
  )
  const groupedEditions = modifiedEditions.filter(
    ({ editionType }) => editionType === EditionType.GraphicFolder
  )
  const uniqueFileNames = [
    ...new Set(groupedEditions.map((edition) => edition.file.fileName)),
  ]
  const zips = uniqueFileNames.map((fileName) => {
    const archiveEditions = groupedEditions
      .filter(({ file }) => file.fileName === fileName)
      .sort(orderByCreatedDateAscending)
    const firstEdition = archiveEditions[0]
    const lastEdition = archiveEditions.slice(-1)[0]
    return {
      archiveName: fileName,
      archiveId: fileName.replace(/\s/g, () => '-'),
      editions: archiveEditions,
      modified: lastEdition.modified,
      modifiedBy: lastEdition.modifiedBy,
      created: firstEdition.created,
      createdBy: firstEdition.createdBy,
    } as IArchive
  })
  return [...singleEditions, ...zips].sort(orderByCreatedDateAscending)
}

export const isArchive = (obj: IArchive | SingleEditionType): obj is IArchive =>
  (obj as IArchive).archiveName !== undefined

export const buildHelpText = (
  text: string,
  editStatusText: string,
  editStatus: EditionStatus
): string => {
  const showEditStatusText = [
    EditionStatus.Update,
    EditionStatus.Correction,
  ].includes(editStatus)
  return `${showEditStatusText ? editStatusText : ''} ${text}`.trim()
}

export const buildTitleHelpText = (
  { title, editStatus = EditionStatus.None }: IEditionMetadataInput,
  packTitle: string
): string => buildHelpText(`${packTitle} ${title}`, editStatus, editStatus)

export const buildDescriptionHelpText = (
  {
    description,
    releaseNote,
    editStatus = EditionStatus.None,
  }: IEditionMetadataInput,
  packDescription: string
): string =>
  buildHelpText(
    `${packDescription} ${description}`,
    `${editStatus} ${releaseNote ?? ''}`,
    editStatus
  )

export const getMediaTypeLabel = ({
  mediaType,
  editionType,
}: IEditionMetadata): string =>
  editionType === EditionType.DataStreamGraphic
    ? 'HTML'
    : editionType === EditionType.DataStreamData
    ? 'JSON'
    : mediaType
